export default class CompactMatchTitleService {
  static tabs = {
    sport: { name: 'sport' },
    category: { name: 'category' },
    tournament: { name: 'tournament' },
  }

  static getContents() {
    if (!APP_SETTINGS.matchDetails.breadcrumbsContent) {
      return [];
    }

    const TabKeys = APP_SETTINGS.matchDetails.breadcrumbsContent.split(',');
    const availableTabs = [];
    TabKeys.forEach((tabKey) => {
      if (typeof this.tabs[tabKey.trim()] !== 'undefined') {
        availableTabs.push(this.tabs[tabKey.trim()]);
      }
    });
    return availableTabs;
  }
}